import React from "react";
import { Stars } from "./Header";

export default function Stats({ progression, metrics }) {
  const commission = progression?.activeCommissionRate ?? 5.0;
  const isBase = commission <= 5.0;
  const diff = (commission - 5.0).toFixed(1);
  const activeRegions = metrics?.activeRegions ?? 1;
  const rating = metrics?.averageRating ?? 4.7;
  const currentLvl = progression?.currentLevel ?? 1;
  const reqL1Clients = progression?.tiers?.[0]?.clients ?? 25;

  return (
    <div className="card border-0 shadow-sm rounded-4 mb-4">
      <div className="card-body">
        <div className="marketing_level_stats_grid">
          {/* Stat 1: Current Commission Rate */}
          <div className="marketing_level_min0">
            <div className="small marketing_level_text_muted">
              Current Commission Rate
            </div>
            <div className="marketing_level_stat_value fw-bold">
              {Number(commission).toFixed(1)}%{" "}
              {!isBase ? (
                <span className="fs-6 marketing_level_text_green fw-semibold">
                  +{diff}% vs Base
                </span>
              ) : (
                <span className="fs-6 text-muted fw-semibold">Base Rate</span>
              )}
            </div>
            <div className="small marketing_level_text_muted">
              {progression?.completedLevelsCount >= 1
                ? `Level ${progression.completedLevelsCount} Milestone Perk Active`
                : `Level 1 Bronze Perk applies at ${reqL1Clients} clients`}
            </div>
          </div>

          {/* Stat 2: Max Achievable Rate */}
          <div className="marketing_level_min0">
            <div className="small marketing_level_text_muted">
              Max Achievable Rate
            </div>
            <div className="marketing_level_stat_value fw-bold">
              15.0%{" "}
              <span className="fs-6 marketing_level_text_muted fw-normal">
                at Tier 10
              </span>
            </div>
            <div className="small marketing_level_text_muted">
              10 Star Elite Max Ceiling
            </div>
          </div>

          {/* Stat 3: Region */}
          <div className="marketing_level_min0">
            <div className="small marketing_level_text_muted">Region</div>
            <div className="marketing_level_stat_value fw-bold">
              {activeRegions}{" "}
              <span className="fs-6 marketing_level_text_muted fw-normal">
                / 10
              </span>{" "}
              <span className="badge marketing_level_bg_green fs-6">
                {activeRegions} Active
              </span>
            </div>
            <div className="small marketing_level_text_muted">
              Lahore HQ active • Karachi &amp; Islamabad next
            </div>
          </div>

          {/* Stat 4: Connectivity Score */}
          <div className="marketing_level_min0">
            <div className="small marketing_level_text_muted">
              Agent Connectivity Score
            </div>
            <div className="marketing_level_stat_value fw-bold">
              {rating} <Stars value={rating} />
            </div>
            <div className="small marketing_level_text_muted">
              {rating >= 4.7
                ? "Passes criteria up to Tier 7 (≥4.7★)"
                : rating >= 4.0
                ? "Passes criteria for Level 2 (≥4.0★)"
                : "Passes baseline criteria for Level 1 (≥3.5★)"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

